// GoogleSignIn.js
import React, { useState } from "react";
import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import { FcGoogle } from "react-icons/fc";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useAuthStore from "../../Store/AuthStore.jsx";
import { googleLoginAPI } from "../../Services/authService.js";
import googlegloader from "../../Assets/Videos/GoogleLoader2.gif";
import { fetchAndSendSavedProductsToApi } from "../../Utils/ProductUtil.jsx";
import { encodeSearchText } from "../../Utils/urlEncoder.js";
import Button from "../ui/Button/Button.jsx";

const GoogleSignIn = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { login } = useAuthStore();
  const [isLoading, setIsLoading] = useState(false);

  const clientId =
    "1075592844578-e6mpdvc4ipm8omdkippd08bavdet3nv6.apps.googleusercontent.com";
  const handleLogin = useGoogleLogin({
    // Key fix: Use 'code' flow like original implementation
    flow: "auth-code",
    clientId: clientId,
    scope: "openid email profile", // Limit to essential scopes
    prompt: "select_account", // Only show prompt when needed
    ux_mode: "popup",
    onSuccess: async (codeResponse) => {
      setIsLoading(true);
      try {
        // Send code to your backend for token exchange
        const apiResponse = await googleLoginAPI(codeResponse.code);

        if (apiResponse.status === 200) {
          const { token, email } = apiResponse.data;
          window.localStorage.setItem("token", token);
          window.localStorage.setItem("email", email);
          window.localStorage.setItem("loggedin", JSON.stringify(true));
          fetchAndSendSavedProductsToApi();
          await login(email, token, apiResponse.data.isNewUser || false, apiResponse.data.userData || null);

          // Check if we have a stored search query from an unauthenticated user
          const unauthUserSearchText = localStorage.getItem("unauthUserSearchText");
          if (unauthUserSearchText) {
            // Use the already encoded search text
            const encodedSearchText = encodeSearchText(unauthUserSearchText);
            history.push(`/search?query=${encodedSearchText}`);
          } else {
            history.push("/search");
          }
        }

      } catch (error) {
        console.error("Login Error:", error);
        alert(t("auth.googleLoginFailed"));
      } finally {
        setIsLoading(false);
      }
    },
    onError: (error) => {
      console.log("Google Login Error:", error);
      setIsLoading(false);
    },
  });

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <Button
        variant="secondary"
        size="md"
        fullWidth
        onClick={handleLogin}
        disabled={isLoading}
        leftIcon={
          isLoading ? (
            <img src={googlegloader} alt="loading" className="h-5 w-5" />
          ) : (
            <FcGoogle className="h-5 w-5" />
          )
        }
      >
        {t("auth.continueWithGoogle")}
      </Button>
    </GoogleOAuthProvider>
  );
};

export default GoogleSignIn;